<template>
  <div>
    <div class="modal-pdv modal-full show" id="modalCaixaAdmin" tabindex="-1" v-if="modal">
      <div class="modal-pdv-content p-md-0" :class="{'modal-admin': admin}">
        <div class="container-fluid height-100 px-3 py-md-3">
          <loading v-show="load" text="Carregando os dados"/>
          <div v-show="!load">
            <modal-menu :menus="menus" :selected="menu" @changeMenu="changeMenu"/>
            <div v-show="menu === 1">
              <div class="border-bottom pb-2 mb-2">
                <div class="row">
                  <div class="col-md-6">
                    <div>#{{dados.id_caixa}} - {{dados.nome}}</div>
                    <div class="small">{{dados.nome_fantasia}}</div>
                    <div class="small"><b>Aberto:</b> {{dados.dt_cadastro}}</div>
                    <div class="small" v-if="dados.dt_finalizacao"><b>Fechado:</b> {{dados.dt_finalizacao ? dados.dt_finalizacao : '-'}}</div>
                  </div>
                  <div class="col-md-6 text-center text-md-right">
                    <hr class="d-md-none">
                    <a class="btn btn-conferido border mr-2 mb-2" href="javascript:"
                       @click="toggleConferenciaCaixa()" v-if="usuario.admin && dados.status === '2'">
                      <span class="pr-1" style="font-size: 14px">Conferido</span>
                      <img class="switch" src="../../../assets/icons/switch-on.svg" v-show="dados.conferido === '1'" alt="Sim"/>
                      <img class="switch" src="../../../assets/icons/switch-off.svg" v-show="dados.conferido !== '1'" alt="Não"/>
                    </a>
                    <a href="javascript:" class="btn btn-primary mr-2 mb-2" title="Imprimir resumo do caixa" @click="imprimirCaixa()" style="width: 52px">
                      <i class="fa fa-print"></i>
                    </a>
                    <a class="btn btn-third mr-2 mb-2" href="#" style="width: 52px" title="Exportar caixa" @click.prevent="imprimirCaixa(true)">
                      <i class="fa fa-file-pdf"></i>
                    </a>
                    <button v-if="dados.status === '1'" class="btn btn-secondary mb-2" @click="toggleStatusCaixa()">Fechar Caixa</button>
                    <button class="btn btn-dark mb-2" @click="toggleStatusCaixa()" v-if="dados.status === '2'">Reabrir Caixa</button>
                  </div>
                </div>
              </div>
              <div class="row no-gutters justify-content-center">
                <div class="col-md-2 mb-2 p-1">
                  <div class="bg-light border rounded text-center p-2 text-dark">
                    <div><b>{{dados.valor_inicial | valor}}</b></div>
                    <div class="small"><b>Valor Inicial</b></div>
                  </div>
                </div>
                <div class="col-md-2 mb-2 p-1">
                  <div class="bg-light border rounded text-center p-2 text-dark">
                    <div><b>{{dados.total_vendas | valor}}</b></div>
                    <div class="small"><b>Vendas</b></div>
                  </div>
                </div>
                <div class="col-md-2 mb-2 p-1">
                  <div class="bg-light border rounded text-center p-2 text-dark">
                    <div><b>{{dados.total_debitos | valor}}</b></div>
                    <div class="small"><b>Débitos</b><tooltip class="ml-1" msg="Débitos recebidos no caixa"/></div>
                  </div>
                </div>
                <div class="col-md-2 mb-2 p-1">
                  <div class="bg-light border rounded text-center p-2" :class="dados.total_movimento < 0 ? 'text-secondary' : 'text-dark'">
                    <div><b>{{dados.total_movimento | valor}}</b></div>
                    <div class="small"><b>Movimentação</b></div>
                  </div>
                </div>
                <div class="col-md-2 mb-2 p-1">
                  <div class="bg-light border rounded text-center p-2" :class="dados.total_caixa < 0 ? 'text-secondary' : 'text-dark'">
                    <div><b>{{dados.total_caixa | valor}}</b></div>
                    <div class="small"><b>Total</b><tooltip class="ml-1" msg="Total das vendas + Valor Inicial + Débitos Recebidos + Movimentação do caixa"/></div>
                  </div>
                </div>
                <div class="col-md-2 mb-2 p-1" v-show="dados.status === '2'">
                  <div class="bg-light border rounded text-center p-2" :class="(total_conferido < dados.total_caixa) ? 'text-secondary' : 'text-success'">
                    <div><b>{{ total_conferido| valor}}</b></div>
                    <div class="small"><b>Conferido</b><tooltip class="ml-1" msg="A soma dos pagamentos conferidos"/></div>
                  </div>
                </div>
              </div>
              <div class="card rounded" style="min-height: 72px">
                <div class="table-responsive">
                  <table class="table table-sm mb-0">
                    <thead class="small bg-light">
                      <tr>
                        <th>Valores</th>
                        <th class="text-center" style="width: 150px">Movimentado</th>
                        <th class="text-center" style="min-width: 125px">Conferido</th>
                        <th class="text-center" style="min-width: 125px" v-if="dados.status === '2'">Saldo</th>
                      </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(p, index) in dados.pagamentos">
                      <td>
                        {{ p.nome_pagamento }}
                        <div class="small" v-if="dados.versao !== '1'">{{ getInfoPagamento(p.codigo_fiscal) }}</div>
                      </td>
                      <td class="text-center">
                        {{ p.valor_recebido | valor }}
                      </td>
                      <td class="text-center" style="width: 150px">
                        <span v-if="dados.status === '1'"> - </span>
                        <money v-model="p.valor_conferido" :id="`inputConferido${index}`" class="form-control" :disabled="dados.conferido === '1' || !p.id_caixa_pagamento"
                               @blur.native="conferirPagamento()" @keyup.enter.native="nextConferido(index)" v-else/>
                      </td>
                      <td class="text-center" v-if="dados.status === '2'" style="width: 150px">
                        <span :class="(p.valor_conferido - p.valor_recebido) >= 0 ? 'text-success' : 'text-secondary'" v-if="p.valor_conferido != p.valor_recebido">
                          {{p.valor_conferido > p.valor_recebido ? '+' : ''}}{{(p.valor_conferido - p.valor_recebido) | valor}}
                        </span>
                        <span v-else><i class="fa fa-check text-success"></i></span>
                      </td>
                    </tr>
                    <tr v-if="dados.status === '2'">
                      <td><b>Saldo</b></td>
                      <td class="text-center">&nbsp;</td>
                      <td class="text-center">&nbsp;</td>
                      <td class="text-center" :class="total_conferido - dados.total_caixa < 0 ? 'text-secondary' : 'text-success'">
                        <b v-if="total_conferido != dados.total_caixa">{{ total_conferido - dados.total_caixa | valor }}</b>
                        <span v-else><i class="fa fa-check text-success"></i></span>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div v-show="menu === 2">
              <div class="row align-items-end mb-3">
                <div class="col-md-3">
                  <label class="small mb-0">Agrupar por</label>
                  <select class="form-control" v-model="relVendas" @change="buscarVendas()">
                    <option value="1">Pagamento</option>
                    <option value="2">Vendas</option>
                  </select>
                </div>
                <div class="col-md-3 mb-3 mb-md-0" v-show="relVendas === '1'">
                  <label class="small mb-0">Forma de Pagamento</label>
                  <select class="form-control" v-model="pesquisa.codigo_fiscal" @change="buscarVendas()">
                    <option value="">Todos</option>
                    <option :value="c.codigo_fiscal" v-for="c in codigos_fiscais">{{ c.nome_pagamento }}</option>
                  </select>
                </div>
                <div class="col-md-3 ml-auto d-flex justify-content-end">
                  <div>
                    <button class="btn btn-info btn-block" @click="getInfoVendas()"><i class="fa fa-info-circle mr-1"></i> Sobre</button>
                  </div>
                  <div class="ml-2" v-if="relVendas === '1'">
                    <a class="btn btn-dark btn-block" href="#" @click.prevent="exportarVendas()"><i class="fa fa-file-pdf mr-1"></i> Exportar</a>
                  </div>
                </div>
              </div>
              <div>
                <div class="card rounded table-responsive">
                  <table class="table table-striped mb-0" v-if="relVendas === '1'">
                    <tr class="bg-light small">
                      <th style="width: 10%">Venda</th>
                      <th style="width: 20%">Pagamento</th>
                      <th style="width: 30%">Tipo</th>
                      <th style="width: 20%">Recebimento</th>
                      <th class="text-center" style="width: 20%">Valor</th>
                    </tr>
                    <tbody>
                    <tr class="pointer" v-for="v in vendas" @click="visualizarComanda(v)">
                      <td>{{ v.id_contador }}</td>
                      <td>{{ v.nome_pagamento }}</td>
                      <td>{{ v | tipo_comanda }}</td>
                      <td>{{ v.data_fechamento }}</td>
                      <td class="text-center">{{ v.valor | valor }}</td>
                    </tr>
                    <tr class="bg-light">
                      <td colspan="4"><b>Total</b></td>
                      <td class="text-center"><b>{{ totalVendas | valor }}</b></td>
                    </tr>
                    </tbody>
                  </table>

                  <table class="table table-sm table-striped mb-0" v-else>
                    <tr class="bg-light small">
                      <th>Venda</th>
                      <th class="text-center">Desconto</th>
                      <th class="text-center" v-if="hasService">Serviço</th>
                      <th class="text-center">Recebido</th>
                    </tr>
                    <tbody>
                    <tr class="pointer" v-for="v in vendas" @click="visualizarComanda(v)">
                      <td>
                        <div>#{{v.id_contador || v.id_comanda}} - {{ v | tipo_comanda }} <span class="badge badge-danger ml-1" v-if="v.status === '3'">Cancelado</span></div>
                        <div class="small">Aberta: {{v.data_comanda}}</div>
                        <div class="small">Finalizada: {{v.data_fechamento}}</div>
                      </td>
                      <td class="text-center">
                        <span v-if="v.desconto > 0">{{v.desconto | valor}}</span><span v-else>-</span>
                      </td>
                      <td class="text-center" v-if="hasService">
                        <span v-if="v.taxa_servico > 0">{{v.taxa_servico | valor}}</span><span v-else>-</span>
                      </td>
                      <td class="text-center">{{v.valor_total | valor}}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div v-show="menu === 3">
              <div class="alert alert-info">
                <i class="fa fa-info-circle mr-1"></i> Nesta guia é exibido os débitos que foram pagos pelos clientes.
              </div>
              <div class="card rounded table-responsive">
                <table class="table table-sm mb-0">
                  <tr class="bg-light small">
                    <th>Débito</th>
                    <th>Pagamento</th>
                    <th class="text-center">Valor</th>
                  </tr>
                  <tr v-for="d in debitos">
                    <td class="py-2">
                      #{{d.id_debito}} | <span class="text-uppercase">{{d.nome_cliente}}</span>
                      <div class="small" v-if="d.obs_debito">Obs: {{d.obs_debito}}</div>
                    </td>
                    <td>{{d.pagamento}}</td>
                    <td class="text-center">{{d.valor_recebido | valor }}</td>
                  </tr>
                </table>
              </div>
            </div>

            <div v-show="menu === 4">
              <div class="card p-3" v-if="dadosM">
                <div class="row align-items-end justify-content-center">
                  <div class="col-lg-6">
                    <label class="small mb-0">Nome / Descrição</label>
                    <input type="text" class="form-control" id="descMovimento" placeholder="Ex: Pagamento motoboy" v-model="dadosM.observacao" :disabled="troco"/>
                  </div>
                  <div class="col-md-4 col-lg-2">
                    <label class="small mb-0">Tipo</label>
                    <select class="form-control" v-model="dadosM.tipo_movimento" :disabled="troco" @change="changeTipoMovimentacao()">
                      <option value="2">Retirada</option>
                      <option value="1">Entrada</option>
                    </select>
                  </div>
                  <div class="col-6 col-md-4 col-lg-2">
                    <label class="small mb-0">Valor</label>
                    <money v-model="dadosM.valor" id="valorCaixa" class="form-control" required/>
                  </div>
                  <div class="col-6 col-md-4 col-lg-2">
                    <label class="small mb-0">Forma de Pagamento</label>
                    <select title="Forma de Pagamento" class="form-control" v-model="dadosM.id_pagamento" :disabled="dadosM.tipo_movimento === '2' || troco">
                      <option :value="f.id_pagamento" v-for="f in formas_pagamento">{{f.nome_pagamento}}</option>
                    </select>
                  </div>
                  <div class="col-md-4 mt-4">
                    <div class="row">
                      <div class="col-6 pr-1">
                        <button class="btn btn-outline-dark btn-block mr-1" type="button" @click="clearMovimentos()" title="Cancelar">Cancelar</button>
                      </div>
                      <div class="col-6 pl-1">
                        <button class="btn btn-success btn-block" title="Alterar" @click="salvarMovimentos()">Salvar</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-show="!dadosM">
                <div class="text-right mb-2">
                  <button class="btn btn-info mr-1" @click="getInfoMovimentacao()"><i class="fa fa-info-circle mr-1"></i> Sobre</button>
                  <button class="btn btn-secondary" @click="adicionarMovimento()"><i class="fa fa fa-plus mr-1"></i> Adicionar</button>
                </div>
                <div class="card rounded table-responsive">
                  <table class="table table-sm mb-0">
                    <tr class="bg-light small">
                      <th>Movimentação</th>
                      <th class="text-center" style="width: 100px">Valor</th>
                      <th class="text-right" style="width: 150px">&nbsp;</th>
                    </tr>
                    <tr v-show="dados.id_caixa">
                      <td class="pointer" @click="editarMovimentos()">
                        <div>Entrada <i class="fa fa-edit text-info small ml-1"></i></div>
                        <div class="small">Dinheiro</div>
                        <div class="small">Valor inicial</div>
                      </td>
                      <td class="text-center">
                        {{ dados.valor_inicial | valor }}
                      </td>
                      <td class="text-right pr-3">
                        <button class="btn btn-sm btn-outline-danger ml-1" style="width: 32px" @click="removerMovimentos()" v-if="dados.conferido !== '1'"><i class="fa fa-trash-alt"></i></button>
                      </td>
                    </tr>
                    <tr v-for="m in dados.movimentos">
                      <td class="pointer" @click="editarMovimentos(m)">
                        <div>{{ m.tipo_movimento === '2' ? 'Retirada' : 'Entrada' }} <i class="fa fa-edit text-info small ml-1"></i></div>
                        <div class="small">{{ m.nome_pagamento }} - {{ m.data_movimento }}</div>
                        <div class="small">{{ m.observacao || ' - ' }}</div>
                      </td>
                      <td class="text-center">
                        {{ m.valor | valor }}
                      </td>
                      <td class="text-right text-nowrap pr-3">
                        <button class="btn btn-sm btn-third ml-1" style="width: 32px" @click="imprimirMovimento(m)"><i class="fa fa-print"></i></button>
                        <button class="btn btn-sm btn-outline-danger ml-1" @click="removerMovimentos(m)" style="width: 32px" v-if="dados.conferido !== '1'"><i class="fa fa-trash-alt"></i></button>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-content-footer bg-light p-2 mt-2 border-top d-flex justify-content-between">
          <button class="btn btn-dark p-3" @click="menu === 1 ? toggleModal(false) : menu = 1">
            <i class="fa fa-chevron-left mr-2"></i>
            <span>Voltar</span>
          </button>
          <button class="btn btn-success p-3" @click="editar(true)" v-show="menu === 1 && dados.status === '2'">
            <i class="fa fa-check mr-2"></i>
            <span>Salvar</span>
          </button>
        </div>
      </div>
    </div>

    <div v-if="admin">
      <finalizar ref="caixaFinalizar" :comanda="comanda" :totalComanda="totalComanda" modal-caixa="true" @cancelar="toggleModal(true)" @comprovante="abrirComprovante"/>
      <modal-option @imprimir="imprimirVenda" gestor="true"/>
    </div>
  </div>
</template>

<script>
  import Loading from "../../../components/commons/Loading";
  import ModalMenu from "../../../components/commons/ModalMenu";
  import Tooltip from "@/components/commons/Tooltip";
  import ModalOption from "@/components/pdv/ModalOption";

  export default {
    components: {ModalOption, Tooltip, Loading, ModalMenu},
    props: ['admin'],
    data() {
      return {
        token: localStorage.getItem('key'),
        modal: false,
        menus: [
          { nome: 'Dados', active: true },
          { nome: 'Vendas', active: true },
          { nome: 'Débitos', active: true },
          { nome: 'Movimentação', active: true }
        ],
        menu: 1,
        id_caixa: 0,
        total_conferido: 0,
        modalFecharCaixa: false,
        load: true,

        dados: {
          nome: '',
          status: 1,
          dt_cadastro: '',
          dt_finalizacao: '',
          valor_inicial: 0,
          total_vendas: 0,
          pagamentos: false,
          movimentos: []
        },

        totalVendas: 0,
        pesquisa: { codigo_fiscal: '' },
        vendas: [],
        debitos: [],

        relVendas: '1',
        formas_pagamento: [],
        codigos_fiscais: [],
        comanda: null,
        totalComanda: 0,
        troco: false,
        dadosM: null
      }
    },

    methods: {
      getCaixa() {
        this.load = true;
        this.$http.get(`caixas/${this.token}/${this.id_caixa}`)
          .then(response => {
            if (response.data) {
              const dados = response.data;
              dados.total_vendas = parseFloat(dados.total_vendas || '0');
              dados.total_debitos = parseFloat(dados.total_debitos || '0');
              dados.total_movimento = parseFloat(dados.total_movimento || '0');
              dados.valor_inicial = parseFloat(dados.valor_inicial || '0');
              dados.total_caixa = parseFloat(dados.total_caixa || '0');
              this.dados = dados;
              this.conferirPagamento();
            }

            this.load = false;

          }, res => {
            console.log(res);
            this.load = false;
            this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
        });
      },

      toggleConferenciaCaixa() {
        const text = this.dados.conferido !== '1' ? 'Deseja marcar como conferido este caixa?' : 'Deseja desmarcar como conferido este caixa?';
        this.$swal({
          text,
          buttons: ['Não', 'Sim'],
          dangerMode: true,
        }).then((result) => {
          if (result) {
            const conferido = this.dados.conferido === '1' ? '2' : '1';
            this.dados.conferido = conferido;
            this.$http.post("caixas/status/" + this.token, { conferido, id_caixa: this.dados.id_caixa })
              .then(res => {
                this.$emit('fechar');
                this.load = false;

              }, res => {
                this.load = false;
                this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
              });
          }
        });
      },

      verificarVendasAbertas(callback) {
        if (this.dados.status === '1') {
          this.$store.state.load = 'Conferindo as vendas';
          this.$http.get('comandas/' + this.token, { params: { status: '1' } })
            .then(response => {
              this.$store.state.load = false;
              const comandas = response.data || [];

              if (comandas.length) {
                this.$swal({
                  title: 'Atenção!',
                  text: "Ainda existem vendas abertas. Deseja continuar?",
                  buttons: ['Não', 'Sim!'],
                  dangerMode: true
                }).then((result) => {
                  if (result) {
                    callback();
                  }
                });

              } else {
                callback();
              }

            }, res => {
              this.$store.state.load = false;
              this.$swal(res.data.msg || 'Erro temporário');
            });
        } else {
          callback();
        }
      },

      toggleStatusCaixa() {
        this.verificarVendasAbertas(() => {
          const text = this.dados.status === '1' ? 'Deseja fechar este caixa?' : 'Deseja reabrir este caixa?';
          this.$swal({ text, buttons: ['Não', 'Sim'], dangerMode: true}).then((result) => {
            if (result) {
              const status = (this.dados.status === '1' ? '2' : '1');
              this.load = true;
              this.$http.post("caixas/status/" + this.token, { status, id_caixa: this.dados.id_caixa })
                .then(res => {
                  this.load = false;
                  this.getCaixa();
                  this.$emit('fechar');

                  if (status === '1') {
                    this.$swal('Caixa reaberto com sucesso!');

                  } else {
                    this.$swal({
                      text: "Caixa fechado com sucesso.\nDeseja imprimir o relatório de caixa?",
                      buttons: ['Não', 'Sim'],
                      dangerMode: true,
                    }).then((result) => {
                      if (result) {
                        this.imprimirCaixa();
                      }
                    });
                  }

                }, res => {
                  this.load = false;
                  this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
                });
            }
          });
        });
      },

      editar(close) {
        this.load = true;
        this.$http.post("caixas/editar/" + this.token, this.dados)
          .then(res => {
            this.load = false;
            this.getCaixa();

            if (close) {
              this.$emit('fechar');
              this.$swal({
                text: "O caixa foi salvo com sucesso. Deseja imprimir o relatório de caixa?",
                buttons: ['Não', 'Sim'],
                dangerMode: true,
              }).then((result) => {
                if (result) {
                  this.imprimirCaixa();
                  this.toggleModal(false);
                }
              });
            }

          }, res => {
            this.load = false;
            this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
          });
      },

      buscarVendas() {
        this.vendas = [];
        this.totalVendas = 0;
        this.load = true;

        if (this.relVendas === '1') {
          this.$http.get(`caixas/pagamentos/${this.token}/${this.id_caixa}`, { params: this.pesquisa })
            .then(response => {
              this.load = false;
              this.vendas = response.data?.vendas || [];
              this.codigos_fiscais = response.data?.pagamentos || [];
              this.totalVendas = this.vendas.map(p => parseFloat(p.valor)).reduce((a, b) => a + b, 0);

            }, res => {
              this.load = false;
              this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
            });

        } else {
          this.$http.get(`caixas/vendas/${this.token}/${this.id_caixa}`, { params: this.pesquisa })
            .then(response => {
              this.load = false;
              this.vendas = response.data || [];

            }, res => {
              this.load = false;
              this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
            });
        }
      },

      getInfoVendas() {
        this.$swal('Nesta seção, você encontrará todas as vendas agrupadas pelo pagamento atribuídas a este caixa');
      },

      exportarVendas() {
        const url = `${this.base_server}api/caixas/pagamentos/${this.token}/${this.dados.id_caixa}`;
        const pars = `?codigo_fiscal=${this.pesquisa.codigo_fiscal}&exportar=true`
        this.$helpers.openArquivo(this, url + pars, 'pdf');
      },

      buscarDebitos() {
        this.load = true;

        this.$http.get('caixas/debitos/' + this.token + '/' + this.id_caixa)
          .then(response => {
            this.debitos = response.data;
            this.load = false;

        }, res => {
            this.load = false;
            this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
        });
      },

      visualizarComanda(c) {
        if (!this.admin) {
          this.toggleModal(false);

          if (this.$route.path !== ('/pdv/' + c.id_comanda)) {
            this.$router.push('/pdv/' + c.id_comanda);
          }

          return;
        }

        this.comanda = null;
        this.$store.state.load = true;

        this.$http.get('comandas/' + this.token + '/' + c.id_comanda)
          .then(response => {
            this.$store.state.load = false;

            if (response.data.id_comanda) {
              this.comanda = response.data;
              this.$nextTick(() => {
                let total = 0;
                this.comanda.itens.forEach((obj) => {
                  total += parseFloat(obj.valor_total);
                });

                this.toggleModal(false);
                this.totalComanda = parseFloat(total.toFixed(2));
                this.$nextTick(() => {
                  this.$refs.caixaFinalizar.openFinalizar();
                });
              });
            }

          }, res => {
            this.$store.state.load = false;
          });
      },

      conferirPagamento() {
        this.total_conferido = 0;
        this.dados.pagamentos.forEach(obj => {
          this.total_conferido += parseFloat(obj.valor_conferido);
        });
      },

      nextConferido(index) {
        this.$helpers.focusElement(`inputConferido${++index}`);
      },

      getInfoPagamento(c) {
        if (c === '1') {
          return 'Pagamentos em dinheiro, Troco inicial, Retiradas';

        } else {
          const pags = this.$store.state.pagamentos_empresa.filter(p => p.codigo_fiscal === c);
          return pags.length ? pags.map(p => p.nome_pagamento).join(', ') : '';
        }
      },

      getInfoMovimentacao() {
        this.$swal('Esta seção é destinada para adicionar (ou alterar) as Retiradas e Entradas do caixa.\n\nPara adicionar uma movimentação de caixa clique no botão "Adicionar" e depois informe o nome/descrição, o tipo (Retirada ou Entrada), o valor e a forma de pagamento.');
      },

      editarMovimentos(r) {
        if (r) {
          if (r.id_conta) {
            this.$swal('Não é possível editar uma movimentação de crédito');
            return;
          }

          this.dadosM = {
            id_movimento: r.id_movimento,
            valor: Math.abs(parseFloat(r.valor)),
            observacao: r.observacao,
            tipo_movimento: r.tipo_movimento,
            id_pagamento: r.id_pagamento
          };

          this.$nextTick(() => {
            this.$helpers.focusElement('descMovimento');
          });

        } else {
          this.troco = true;
          this.dadosM = {
            id_movimento: null, valor: this.dados.valor_inicial,
            id_pagamento: '1', trico: true, tipo_movimento: '1', data_movimento: null,
            observacao: 'Valor Inicial'
          };

          this.$nextTick(() => {
            this.$helpers.focusElement('valorCaixa');
          });
        }
      },

      removerMovimentos(m) {
        if (!m) {
          this.$swal('Não é possível remover um valor Inicial');
          return;
        }

        const text = m.id_conta ? 'Atenção, será removido a movimentação e o crédito deste cliente, deseja continuar?' : 'Deseja remover esta movimentação?';
        this.$swal({
          text,
          dangerMode: true,
          buttons: ["Cancelar", "Sim!"]
        }).then((result) => {
          if (result) {
            this.dadosM = m;
            this.dadosM.valor = Math.abs(parseFloat(m.valor));
            this.dadosM.deletar = 1;
            this.salvarMovimentos(m);
          }
        });
      },

      salvarMovimentos() {
        if (this.troco) {
          this.dados.valor_inicial = this.dadosM.valor;
          this.editar();
          this.clearMovimentos();
          return;
        }

        if (this.dadosM.valor <= 0) {
          this.$swal('O valor é obrigatório');
          return;
        }

        this.dadosM.id_caixa = this.dados.id_caixa;
        this.$store.state.load = true;
        this.$http.post("caixas/movimentos/" + this.token, this.dadosM)
          .then(res => {
            this.$store.state.load = false;

            if (res.data && res.data.success) {
              this.getCaixa();
              this.clearMovimentos();

            } else {
              this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
            }

          }, res => {
            this.$store.state.load = false;
            this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
          });
      },

      adicionarMovimento() {
        this.dadosM = {
          tipo_movimento: '2',
          id_pagamento: '1',
          valor: '',
          observacao: ''
        };

        this.$nextTick(() => {
          this.$helpers.focusElement('descMovimento');
        });
      },

      clearMovimentos() {
        this.troco = false;
        this.dadosM = null;
      },

      changeTipoMovimentacao() {
        if (this.dadosM.tipo_movimento === '2') {
          this.dadosM.id_pagamento = '1';
        }
      },

      changeMenu(m) {
        this.menu = m;

        switch (m) {
          case 2:
            if (!this.vendas.length) {
              this.buscarVendas();
            }

            break;

          case 3:
            if (!this.debitos.length) {
              this.buscarDebitos();
            }

            break;

          case 4:
            this.clearMovimentos();
            break;
        }
      },

      clear() {
        this.menu = 1;
        this.totalVendas = 0;
        this.vendas = [];
        this.debitos = [];
      },

      imprimirCaixa(pdf) {
        const url = `${this.base_server}api/caixas/${this.token}/${this.dados.id_caixa}?html=true&`;

        if (pdf) {
          this.$helpers.openArquivo(this, url + 'pdf=true', 'pdf');

        } else {
          const empresa = localStorage.getItem('token');
          this.$helpers.imprimirUrl(this, url, empresa, 'Comprovante Caixa');
        }
      },

      imprimirVenda(id_comanda) {
        if (!id_comanda) {
          return;
        }

        const empresa = localStorage.getItem('token');
        const url = this.base_server + "api/comprovante/" + empresa + "/" + id_comanda + "?";
        this.$helpers.imprimirUrl(this, url, empresa, "Comprovante Venda " + id_comanda);
      },

      imprimirMovimento(m) {
        const url = `${this.base_server}api/caixas/movimentos/${this.token}?id_movimento=${m.id_movimento}&`;
        const empresa = localStorage.getItem('token');
        this.$helpers.imprimirUrl(this, url, empresa, "Comprovante Movimentação");
      },

      abrirComprovante() {
        this.toggleModal(true);
        this.$emit('abrirComprovante', this.comanda, true);
      },

      toggleModal(m) {
        this.modal = m;
        this.$nextTick(() => {
          this.$helpers.toggleModal(m, 'modalCaixaAdmin', this.toggleModal);
        });
      }
    },

    mounted() {
      this.formas_pagamento = this.$store.state.pagamentos_empresa.filter(f => !['2','34'].includes(f.id_pagamento));
    },

    created() {
      this.$parent.$off('openModalCaixa');

      this.$parent.$on('openModalCaixa', (id_caixa) => {
        this.toggleModal(true);
        this.id_caixa = id_caixa;
        this.clearMovimentos();
        this.clear();
        this.getCaixa();
      });
    },

    computed: {
      usuario() {
        return this.$store.state.dataUser
      },

      hasService() {
        return this.$store.state.pdv.taxa_servico !== '0';
      }
    },

    beforeDestroy() {
      this.$parent.$off('openModalCaixa');
    },

    filters: {
      tipo_comanda(comanda) {
        if (comanda) {
          switch (parseInt(comanda.tipo_comanda)) {
            case 1:
              return "Mesa: " + comanda.mesa;

            case 2:
              return "Delivery";

            case 3:
              return "Comanda: " + comanda.ref_comanda;

            case 4:
              return "Venda Rápida";

            case 5:
              return "Balcão";
          }
        }
      }
    }
  }
</script>

<style scoped>
 .modal-pdv.modal-full .modal-admin {
   min-height: calc(100vh - 90px);
   margin-top: 74px;
 }

 .btn-conferido {
   padding: 4px 12px;
   display: inline-block;
   border-radius: 18px;
 }

 .btn-conferido img {
   width: 30px;
 }

 @media (min-width: 767px) {
   .height-100 {
     margin-bottom: 72px;
   }
 }
</style>
